import React, { useState } from 'react';
import styles from '../../Payments.module.css';

const faqData = [
  {
    q: 'What payment methods can I accept?',
    a: 'Fyntiq Wallet, every major card, Apple Pay, Google Pay, Cash App Pay, bank transfer (ACH), and financing through Affirm, Klarna, and Afterpay — with Fyntiq Financing coming soon.',
  },
  {
    q: 'When do I get paid?',
    a: 'As soon as the same day when customers pay with Fyntiq Wallet, and about two business days for cards and bank transfers. Timing can vary by method and account status.',
  },
  {
    q: 'Do customers need a Fyntiq account to pay?',
    a: 'No. Customers can pay by card, Apple Pay, Google Pay, Cash App Pay, or bank transfer without signing up. A Fyntiq Wallet just adds faster checkout.',
  },
  {
    q: 'Is checkout secure?',
    a: 'Yes. Payments run through an encrypted, PCI-compliant checkout, and eligible fraudulent disputes are covered by built-in chargeback protection.',
  },
  {
    q: 'What does it cost?',
    a: "It's free to get started — you only pay standard per-transaction processing. See our Pricing page for full details.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Payment questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div className={styles.faqQ} onClick={() => setOpenIndex(openIndex === i ? -1 : i)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}>
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
